import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import SurplusResourcesReplacement41_4bTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const SurplusResourcesReplacement41_4b = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_RESOURCES_REPLACEMENT") || "Surplus resources"}
        subDescription={t("SURPLUS_RESOURCES_REPLACEMENT_41_4B_DESC") || "These consist of the removed old components or units that are no longer functional. They leave the system as resources to be recycled, recovered, or disposed of."}
        isNormal={true}
        number={"41.4b"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`surplus-resources-replacement-41-4b-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <SurplusResourcesReplacement41_4bTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default SurplusResourcesReplacement41_4b;

